/**
 * The main component that renders single TabComponent
 * instances.
 */

import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Output,
  QueryList,
  ViewChild,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { SocketService } from '../../common/services/Socket.service';
import { DynamicTabsDirective } from './dynamic-tabs.directive';

import { UserService } from '../../common/services/User.service';
import { TicketService } from '../../common/services/Ticket.service';
import { OrganizeService } from '../../common/services/Organize.service';
import { GroupService } from 'app/common/services/Group.service';
import { UserSharedService } from '../../pages/admin/icontact/customer/UserSharedService';
import { ContactService } from '../../common/services/Contact.service';

import { TabComponent } from './tab.component';
import { BaseComponent } from '../../components/base.component';

import { AgentConst } from '../../pages/admin/icontact/setting/expert/agent/agent.const';
import { FormFieldType, ModalType } from '../../components/modals/modal-form-template/modal-form.const';
import * as _ from 'lodash';
import { isEmail, isPhoneNumber } from '../../common/utils/validate';
import { showPhoneNumberInString } from '../../common/utils/common';

declare var $: any;

@Component({
  selector: 'my-tabs',
  templateUrl: './tabs.template.html',
  styleUrls: ['tabs.style.css'],
  providers: [UserService, TicketService, OrganizeService, GroupService, ContactService],
})
export class TabsComponent extends BaseComponent implements AfterContentInit {
  @ViewChild(DynamicTabsDirective) dynamicTabPlaceholder: DynamicTabsDirective;
  @ViewChild('optionMenu') optionMenu: ElementRef;
  @ViewChild('templateUser') templateUser: ElementRef;
  @ViewChild('templateOrganize') templateOrganize: ElementRef;

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
  @Output('clickTabFirst') clickTabFirst = new EventEmitter();

  dynamicTabs: TabComponent[] = [];
  public icon: any = 'edit';
  public modelOrganize: any = {};

  public list: any = [];
  public max: Number = 6;
  public allGroup: any = [];
  public is_load_data = false;
  public userRole = [];
  // @ViewChild('container', {read: ViewContainerRef}) dynamicTabPlaceholder;
  protected readonly JSON = JSON;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private userService: UserService,
    private ticketService: TicketService,
    private socketService: SocketService,
    private organizeService: OrganizeService,
    private groupService: GroupService,
    private contactService: ContactService,
    private sharedService: UserSharedService
  ) {
    super(changeDetector, toastr, modalService);
    this.userRole = [
      { id: '', text: 'Chọn' },
      { id: 'end_user', text: 'Khách hàng' },
      // ...AgentConst.userRoleArray()
    ];
    this.loadLatestTicket();
    this.socketService.missionAnnounced$.subscribe(mission => {
      if (mission.action == 'reloadLastestTicket') {
        this.loadLatestTicket();
      }
    });
    this.sharedService.onUserUpdated.subscribe(data => {
      this.dynamicTabs.map(tab => {
        if (tab.dataContext.detail._id == data._id) {
          tab.title = data.name;
        }
        return tab;
      });
    });
    this.sharedService.onTicketUpdate.subscribe(data => {
      this.dynamicTabs.map(tab => {
        if (tab.dataContext.detail._id == data._id) {
          tab.title = data.subject;
        }
        return tab;
      });
    });
  }

  isArrays(obj: any) {
    return Array.isArray(obj);
  }

  isString(obj: any) {
    return typeof obj === 'string';
  }

  openTicket(ticket: any) {
    this.userService
      .find({ _id: ticket.requester_id })
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          ticket.request = res.data;
          this.socketService.opentab(ticket, 'ticket', 'edit');
        }
      });
  }

  loadLatestTicket() {
    this.ticketService
      .list({ limit: 3 })
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          this.list = res.data.tickets;
        }
      });
  }

  // contentChildren are set
  ngAfterContentInit() {
    const activeTabs = this.tabs.filter(tab => tab.active);
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first, 0, true);
    }
  }

  openTab(title: string, template, data: any, isCloseable = false) {
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(TabComponent);
    const componentRef = this.dynamicTabPlaceholder.viewContainer.createComponent(componentFactory);
    const instance: TabComponent = componentRef.instance as TabComponent;
    instance.title = title;
    instance.template = template;
    instance.dataContext = data;
    instance.tabIndex = this.dynamicTabs.length;
    instance.isCloseable = isCloseable;
    this.dynamicTabs.push(componentRef.instance as TabComponent);
    this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1], this.dynamicTabs.length);
  }

  selectTab(tab: TabComponent, index, is_load = false) {
    this.tabs.toArray().forEach(tab => (tab.active = false));
    this.dynamicTabs.forEach(tab => (tab.active = false));
    if (tab.title != 'Thêm') {
      $('.tab-content').css('display', 'block');
      $('.main-content').css('display', 'none');
    } else {
      $('.tab-content').css('display', 'none');
      $('.main-content').css('display', 'block');
    }
    tab.active = true;
    if (index == undefined && !is_load && tab.title == 'Thêm') {
      this.clickTabFirst.emit(true);
    }
  }

  trackByFn(i: number) {
    return i;
  }

  closeTab(tab: TabComponent) {
    if (tab.dataContext.action == 'ring') {
      return;
    }
    for (let i = 0; i < this.dynamicTabs.length; i++) {
      if (this.dynamicTabs[i] === tab) {
        this.dynamicTabs.splice(i, 1);
        this.dynamicTabPlaceholder.viewContainer.remove(i);
        if (i == 0) {
          this.selectTab(this.tabs.first, 0);
        } else {
          this.selectTab(this.dynamicTabs[i - 1], i - 1);
        }
        break;
      }
    }
  }

  closeActiveTab() {
    const activeTabs = this.dynamicTabs.filter(tab => tab.active);
    if (activeTabs.length > 0) {
      // close the 1st active tab (should only be one at a time)
      this.closeTab(activeTabs[0]);
    }
  }

  openNewTab(tab: TabComponent) {
    event.stopPropagation();
    this.selectTab(tab, undefined);
  }

  async setUpModelCreateUser() {
    this.modelContent = {
      type: ModalType.Primary,
      title: 'Thêm mới khách hàng ',
      submit_title: 'Thêm mới',
    };
    this.modelDisplay = [
      {
        key: 'name',
        label: 'Tên người dùng',
        type: FormFieldType.Text,
        value: this.model.name,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
      {
        key: 'phone',
        label: 'Số điện thoại',
        type: FormFieldType.Text,
        value: this.model.phone,
        required: false,
        disabled: false,
        width: 'full',
        order: 1,
      },
      {
        key: 'email',
        label: 'Email',
        type: FormFieldType.Text,
        value: this.model.email,
        required: false,
        disabled: false,
        width: 'full',
        order: 2,
      },
    ];
    if (this.model.role) {
      this.modelDisplay.push({
        key: 'group_id',
        label: 'Nhóm khách hàng',
        type: FormFieldType.Select2,
        value: this.model.group_id,
        required: false,
        disabled: false,
        width: 'full',
        order: 4,
        options: {
          data: this.allGroup,
        },
      });
    }
  }

  async openCreateUser() {
    event.stopPropagation();
    await this.getGroup();
    this.model = {};
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-md',
    };
    this.model.role = 'end_user';
    await this.setUpModelCreateUser();
    this.openModal(this.templateUser, config, this.model, {
      modelContent: this.modelContent,
      modelDisplay: this.modelDisplay,
    });
  }

  openCreateOrganize() {
    event.stopPropagation();
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-md',
    };
    this.modelOrganize = {};
    this.message = null;
    this.openModal(this.templateOrganize, config);
  }

  async getGroup() {
    await this.groupService.allGroup({ target: 'end_user' }).subscribe(res => {
      const groupList = [{ id: '', text: 'Chọn' }];
      res.data.forEach((c: any) => {
        groupList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allGroup = groupList;
      this.is_load_data = false;
    });
  }

  changedGroup($event) {
    if (!this.is_load_data) {
      this.model['group_id'] = $event.value;
    }
  }

  addUser() {
    const payload = {
      name: this.model.name,
      phone: this.model.phone,
      email: this.model.email,
      role: this.model.role,
    };
    if (this.model.role === 'end_user') {
      this.contactService.create(payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.throwSuccess('Thêm mới thành công!');
            this.sharedService.onUserCreate.emit(res.data);
            this.closeModal();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
        }
      );
    } else {
      this.userService.create(this.model).subscribe(
        res => {
          if (res.status == 200 && res.error == false) {
            this.throwSuccess('Thêm mới thành công!');
            this.sharedService.onUserCreate.emit(res.data);
            this.closeModal();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }

  addOrganize() {
    this.organizeService.create(this.modelOrganize).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.modalRef.hide();
          this.toastr.success('Cập nhật thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        } else {
          this.toastr.error('Lưu không thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        setTimeout(() => (this.message = null), 3000);
      }
    );
  }

  async handleSubmit(item?: any, type?: string) {
    this.model = _.merge({}, this.model, item);
    switch (type) {
      case 'create_user':
        this.addUser();
        break;
      case 'create_organize':
        this.addOrganize();
        break;
      default:
        break;
    }
  }

  async onChangeValueModel(key, item?: any, type?: string) {
    this.message = null;
    this.model = _.merge({}, this.model, item);
    if (type === 'create_user') {
      switch (key) {
        case 'email':
          if (!isEmail(item[key]) && item[key]) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Email không hợp lệ!',
            };
          }
          break;
        case 'phone':
          if (!isPhoneNumber(item[key]) && item[key]) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Số điện thoại không hợp lệ!',
            };
          }
          break;
        case 'role':
          this.model.group_id = null;
          if (this.model.role === 'end_user') {
            this.model.agent_id = null;
          }
          break;
      }
    }
    await this.setUpModelCreateUser();
  }

  public readonly showPhoneNumberInString = showPhoneNumberInString;
}



// WEBPACK FOOTER //
// ./src/app/layout/tabs/tabs.component.ts